import { useState, useEffect } from 'react'

export default function useIsVisible(elementRef, threshold = 0.1) {
  const [intersecting, setIntersecting] = useState(false)

  useEffect(() => {
    let ref = null
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), {
      threshold: threshold
    })

    if (elementRef && elementRef.current) {
      observer.observe(elementRef.current)
      ref = elementRef.current
    }

    return () => {
      if (ref) observer.unobserve(ref)
    }
  }, [elementRef, threshold])

  return intersecting
}
